import { Card, CardContent } from "../ui/card";
import { TestSubsection } from "./TestSection";
import * as tests from "./testDefinitions";
import { Shield, Building2, Activity, Database, Settings } from "lucide-react";

export const PlatformAdminSection = ({ testResults }) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <h3 className="text-lg font-semibold mb-4">Platform Administration</h3>
        
        <TestSubsection
          icon={Building2}
          iconColor="text-blue-600"
          title="Organization CRUD"
          tests={tests.platformAdminTests.slice(0, 5)}
          results={testResults['platform-admin'] || testResults.platformAdmin}
        />
        
        <TestSubsection
          icon={Activity}
          iconColor="text-purple-600"
          title="Activity Log System"
          tests={tests.platformAdminTests.slice(5, 10)}
          results={testResults['platform-admin'] || testResults.platformAdmin}
        />
        
        <TestSubsection
          icon={Shield}
          iconColor="text-red-600"
          title="Super Admin Operations"
          tests={tests.platformAdminTests.slice(10, 15)}
          results={testResults['platform-admin'] || testResults.platformAdmin}
        />
        
        <TestSubsection
          icon={Database}
          iconColor="text-green-600"
          title="Test Org Management"
          tests={tests.platformAdminTests.slice(15, 18)}
          results={testResults['platform-admin'] || testResults.platformAdmin}
        />
        
        <TestSubsection
          icon={Settings}
          iconColor="text-orange-600"
          title="Health Dashboard Infrastructure"
          tests={tests.platformAdminTests.slice(18, 22)}
          results={testResults['platform-admin'] || testResults.platformAdmin}
        />
        
        <TestSubsection
          icon={Database}
          iconColor="text-cyan-600"
          title="Platform Metrics"
          tests={tests.platformAdminTests.slice(22, 25)}
          results={testResults['platform-admin'] || testResults.platformAdmin}
        />
      </CardContent>
    </Card>
  );
};
